// extracted by mini-css-extract-plugin
module.exports = {"twitterContainer":"TwitterShare_twitterContainer__3zFLl","iconTwitterBird":"TwitterShare_iconTwitterBird__12sJh"};